<template>
    <v-container fluid>
      <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
        <v-layout align-center pr-4>
          <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
          <v-layout column>
            <div>
              <strong>{{ snackbar.title }}</strong>
            </div>
            <div>{{ snackbar.text }}</div>
          </v-layout>
        </v-layout>
        <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-snackbar>
      <v-row no-gutters>
        <v-col cols="7" class="main-part d-none d-md-none d-lg-flex">
          <div class="d-flex">
            <v-img class="w-100" src="../../../../assets/logo.png" contain></v-img>
          </div>
        </v-col>
        <v-col cols="12" lg="5" class="login-part mt-15 d-flex align-center justify-center">
          <v-row no-gutters class="align-start">
            <v-col cols="12" class="login-part d-flex align-center justify-center flex-column">
              <div class="login-wrapper pt-16 pb-10 px-1 px-md-0" style="  max-height: 90vh; overflow: auto;">
                <v-tabs
                    v-model="loginTabs"
                    class="minWidthLoginTabs"
                    fixed-tabs
                    >
                  <template v-if="languageData.tabHead">
                    <v-tab class="tab-text-size tab-custom" :href="`#tab-newUser`">
                      {{ languageData.tabHead.registerTab }}
                    </v-tab>
                    <v-tab class="tab-text-size tab-custom" :href="`#tab-login`">
                      {{ languageData.tabHead.loginTab }}
                    </v-tab>
                  </template>
                  <v-tab-item
                    :value="'tab-login'">
                    <LoginForm></LoginForm>
                  </v-tab-item>

                  <v-tab-item
                    :value="'tab-newUser'">
                    <RegisterForm @setTabLogin="setTabLogin"></RegisterForm>
                  </v-tab-item>
                </v-tabs>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
  import RegisterForm from "../../components/RegisterForm/RegisterForm";
  import LoginForm from "../../components/LoginForm/LoginForm";
  import eventBus from "../../../../event-bus/eventBus";

  export default {
    name: "LoginMain",
    data() {
      return {
        loginTabs: '',
        alert: false,
        value: false,
        snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: "top",
          text: null,
          corner: 'right',
          timeout: 7500,
          title: null,
          visible: false
        }
      }
    },
    components: {
      LoginForm,
      RegisterForm
    },
    methods: {
      setTabLogin: function() {
        this.loginTabs = 'tab-login';
      },
      getSnackbarSuccess: function(title, message) {
        this.snackbar = {
          color: "success",
          icon: "check_circle",
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          corner: 'right',
          title: title,
          text: message,
          visible: true
        };
      }
    },
    watch: {
      languageData (val) {
        const registerStatus = new URLSearchParams(window.location.search).get("regStatus");

        if(registerStatus === "OK" && val.registerInfo) {
          this.setTabLogin();
          this.getSnackbarSuccess(this.languageData.registerInfo.successTitle, this.languageData.registerInfo.successMessage);
        }

      }
    },
    mounted: function() {
      this.updateLanguage(this.getCurrentLanguage);
      eventBus.$on("setTabLogin", () => {
        this.setTabLogin();
      });


    },
  }
</script>

<style src="./Login.scss" lang="scss"></style>